import script from "./phonenavmenu.vue?vue&type=script&setup=true&lang=js"
export * from "./phonenavmenu.vue?vue&type=script&setup=true&lang=js"

import "./phonenavmenu.vue?vue&type=style&index=0&id=151c5d04&lang=less&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-151c5d04"]])

export default __exports__